import { NgModule } from '@angular/core';
import { WebcamComponent } from './webcam.component';

@NgModule({
  imports: [WebcamComponent],
  exports: [WebcamComponent],
})
export class WebcamModule {}